module.exports = __webpack_public_path__ + "static/img/zzc_5.6eea722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_5.png
// module id = dR42
// module chunks = 19